import Axios from "axios";
// import { domain_app, domain_datatrax } from "./config";

function intercept(axios) {
  axios.interceptors.request.use((req) => {
    let id_token = localStorage.getItem("id_token");
    delete req.headers.Authorization;
    delete req.headers.common.Authorization;
    req.data = req.data ? req.data : {};
    if (id_token) {
      req.data.access_token = id_token;
    }
    if (req.data instanceof FormData) {
      req.headers["Content-Type"] = "multipart/form-data";
      if (localStorage.getItem("utype")) {
        req.data.append("utype", localStorage.getItem("utype"));
      }
      req.data.append("access_token", id_token);
    } else {
      if (localStorage.getItem("utype")) {
        req.data.utype = localStorage.getItem("utype");
      }
      req.headers["Content-Type"] = "application/x-www-form-urlencoded";
      req.data = Object.entries(req.data)
        .map((e) => e.map(encodeURIComponent).join("="))
        .join("&");
    }
    // delete req.headers.Authorization;
    return req;
  });

  axios.interceptors.response.use(
    function (response) {
      return response.data;
    },
    function (error) {
      return Promise.reject(error);
    }
  );
  return axios;
}

function ApiDatatrax() {
  return intercept(Axios.create({
    baseURL: window.APP_CONFIG?.API_REMOTE_URL || "https://fallback-datatrax.com",
    params: {
      "X-company": window.APP_CONFIG?.COMPANY,
    }
  }));
}

function ApiService() {
  return intercept(Axios.create({
    baseURL: window.APP_CONFIG?.API_BASE_URL || "https://fallback-datatrax.com",
    params: {
      "X-company": window.APP_CONFIG?.COMPANY,
    }
  }));
}

async function fetchWithRetry(url, retries = 3) {
  let attempt = 0;
  // use for loop to retry 3 times at most
  while (attempt < retries) {
    try {
      const response = await Axios.create({
        baseURL: window.APP_CONFIG?.API_REMOTE_URL,
        params: {
          "X-company": window.APP_CONFIG?.COMPANY,
        }
      }).get(url);
      return response.data; // Success: Return data
    } catch (error) {
      attempt++;
      console.log(`Attempt ${attempt} failed. Retrying...`);
      // delay for 1 second before retrying
      await new Promise((resolve) => setTimeout(resolve, 1000 * attempt));
      // If the last attempt fails, throw the error
      if (attempt === retries) {
        throw error; // Fail after exhausting retries
      }
    }
  }
}

export { ApiDatatrax, ApiService, fetchWithRetry };
